import { AlignmentType, Footer, Header, ImageRun, Paragraph } from "docx";
import {
  grupo_forte_footer,
  grupo_forte_header,
} from "../docImages/grupo_forte";

export const styles_grupo_forte = {
  companyId: ["12429"],
  companyName: "Grupo Forte",
  font: "Calibri",
  titleSize: 28,
  textSize: 22,
  lineSpacing: 380,
  marginRight: 500,
  marginLeft: 500,
  beforeParagraph: 0,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 100,
          after: 500,
        },
        alignment: AlignmentType.CENTER,
        indent: {
          left: 0,
        },
        children: [
          new ImageRun({
            data: grupo_forte_header,
            transformation: {
              width: 750,
              height: 100,
            },
          }),
        ],
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        spacing: {
          before: 800,
          after: 350,
        },
        alignment: AlignmentType.CENTER,
        indent: {
          left: 0,
        },
        children: [
          new ImageRun({
            data: grupo_forte_footer,
            transformation: {
              width: 750,
              height: 100,
            },
          }),
        ],
      }),
    ],
  }),
};
